import { statusOf } from "./catalogModel";

export const productLabel = (p) => `${p.name}${p.edition ? ` (${p.edition})` : ""}`;

/** What the row switch and kebab menu can do for a product; shared by the table and the mobile cards. */
export function actionState(p) {
  const status = statusOf(p);
  return {
    status,
    canVerify: status === "unverified",
    canToggle: status === "active" || status === "verified",
    active: status === "active",
  };
}

export function menuItems(p, { onEdit, onToggle }) {
  const { active } = actionState(p);
  return [
    { icon: "pencil", label: "Edit product", onSelect: () => onEdit(p) },
    { icon: "layers", label: "Manage modules", onSelect: () => onEdit(p) },
    ...(active ? ["-", { icon: "minusCircle", label: "Deactivate", danger: true, onSelect: () => onToggle(p, false) }] : []),
  ];
}
